// extracted by mini-css-extract-plugin
export var alignCenter = "_a3-d";
export var bannerShown = "_a3-6";
export var buttonContent = "_a3-0";
export var cardList = "_a3-1";
export var centerContent = "_a3-2";
export var chevron = "_a3-3";
export var closePanelButton = "_a3-k";
export var conversationContextContainer = "_a3-l";
export var conversationDetailContainer = "_a3-4";
export var detailWrapper = "_a3-7";
export var dropdownButton = "_a3-e";
export var dropdownTitle = "_a3-9";
export var fullHeight = "_a3-5";
export var hidden = "_a3-a";
export var icon = "_a3-b";
export var mergeSuggestionWrapper = "_a3-m";
export var panel = "_a3-i";
export var portalButtonsWrapper = "_a3-c";
export var right = "_a3-j";
export var tableSummaryContainer = "_a3-8";
export var tableSummaryHeader = "_a3-g";
export var threeDotsButton = "_a3-f";
export var wide = "_a3-h";